import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selAddress: null,
    selPID: null,
    matID: null,
    latlng: []
  },
  mutations: {
    selAddress(state,selAddress){
      state.selAddress = selAddress
    },
    latlng(state,latlng){
      state.latlng = latlng
    },
    selPID(state, selPID){
      state.selPID = selPID
    },
    matID(state,matID){
      state.matID = matID
    }
  },
  actions: {

  }
})
